var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewNote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.795,
    height: 35.623,
    viewBox: "0 0 37.795 35.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2325.747,291.686l-16.239,28.5-21.556-12.234,11.124-19.539,14.079-3.849Z",
    transform: "translate(-2287.952 -284.566)",
    fill: "#0086cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2377.25,284.566l-6.3,10.3-1.2-5.471-6.583-.974Z",
    transform: "translate(-2352.047 -284.566)",
    fill: "#02628d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2370.952,317.04l-2.108-4.143-5.673-2.3,6.583.974Z",
    transform: "translate(-2352.047 -306.745)",
    fill: "#0375aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415.176,284.566l-7.5,4.824,1.2,5.471Z",
    transform: "translate(-2389.973 -284.566)",
    fill: "#014564"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(14.689 23.132)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNote);
export default __webpack_public_path__ + "static/media/new-note.48bd033b7fdca2028265a3b051d64c2b.svg";
export { ForwardRef as ReactComponent };